module.exports = __webpack_public_path__ + "static/media/banner.cbd7ab5f.png";